import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './NotFoundMessage.module.css';

const NotFoundMessage = props => {
  return (
    <div className={classes.container}>
      <aside className={classes.noSubjectsContainer}>
        <figure className={classes.infoAvatar}>
          <img
            className={classes.img}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/info.png"
            alt=""
          />
        </figure>
        {props.type === 'subject' ? (
          <div>
            <p className={classes.helpPrincipalText}>
              No cuentas con registro de Materias en la Universidad
              de la Ciencias
            </p>
            <p className={classes.helpSecondaryText}>
              Asegúrate de iniciar sesión en Mayahii con tu cuenta de
              correo de UDC. Ejemplo:
              nombre.apellido@universidaddelasciencias.edu.mx.
            </p>
          </div>
        ) : props.type === 'invitation' ? (
          <div>
            <p className={classes.helpPrincipalText}>
              No cuentas con invitaciones de Materias en la
              Universidad de la Ciencias
            </p>
            <p className={classes.helpSecondaryText}>
              Asegúrate de iniciar sesión en Mayahii con tu cuenta de
              correo de UDC. Ejemplo:
              nombre.apellido@universidaddelasciencias.edu.mx.
            </p>
          </div>
        ) : props.type === 'portfolio' ? (
          <div>
            <p className={classes.helpPrincipalText}>
              No has terminado ningún curso todavía
            </p>
            <p className={classes.helpSecondaryText}>
              Con la cuenta: <strong>userInSession.email</strong>
            </p>
            <p className={classes.helpSecondaryText}>
              En este apartado encontrarás la lista de todos los
              diplomas que obtengas en el tiempo, y desde aquí podrás
              bajarlos o compartirlos.
            </p>
          </div>
        ) : (
          ''
        )}
        <p className={classes.helpSecondaryText}>
          No te preocupes, si crees que se trata de un error o tienes
          alguna duda, contáctanos a través del Centro de Ayuda
        </p>
        <Button
          className={classes.infoButton}
          component="a"
          href="http://ayuda.mayahii.com/"
          target="_blank"
        >
          <figure className={classes.helpButton}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/CentroAyudaNewUDC.png"
              alt=""
            />
          </figure>
        </Button>
        <p className={classes.descriptionText}>Centro de ayuda</p>
      </aside>
    </div>
  );
};

NotFoundMessage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  type: PropTypes.string
};

export default NotFoundMessage;
